require("./sass/vendor/normalize/_normalize.scss");

require("./sass/core/_base.scss");
require("./sass/core/_fonts.scss");
require("./sass/core/_typography.scss");
require("./sass/core/_helpers.scss");
require("./sass/core/_variables.scss");

require("./sass/blocks/_buttons.scss");
require("./sass/blocks/_title.scss");
require("./sass/blocks/_form.scss");
require("./sass/blocks/_header.scss");
require("./sass/blocks/_header-mobile.scss");
require("./sass/blocks/_menu.scss");
require("./sass/blocks/_promo.scss");
require("./sass/blocks/_popular-goods.scss");
require("./sass/blocks/cookie-info.scss");
require("./sass/blocks/_product.scss");
require("./sass/blocks/_about-store.scss");
require("./sass/blocks/_menu-footer.scss");
require("./sass/blocks/_footer.scss");
require("./sass/blocks/_content.scss");
require("./sass/blocks/_aside.scss");
require("./sass/blocks/_horizontal-slider.scss");
require("./sass/blocks/_main.scss");
require("./sass/blocks/_catalog-menu.scss");
require("./sass/blocks/_compare-products-btn.scss");
require("./sass/blocks/_filter.scss");
require("./sass/blocks/_banner.scss");
require("./sass/blocks/_recent-goods.scss")
require("./sass/blocks/_breadcrumbs.scss");
require("./sass/blocks/_main-description.scss");
require("./sass/blocks/_catalog.scss");
require("./sass/blocks/_small-slider.scss");
require("./sass/blocks/_products-catalog.scss");
require("./sass/blocks/_pagination.scss");
require("./sass/blocks/_compare-products.scss");
require("./sass/blocks/_card-product.scss");
require("./sass/blocks/_pop-up.scss");
require("./sass/blocks/_cart.scss");
require("./sass/blocks/_table-goods.scss");
require("./sass/blocks/_personal-area.scss");
require("./sass/blocks/_links.scss");
require("./sass/blocks/_substrate.scss");
require("./sass/blocks/_change-data.scss");
require("./sass/blocks/_password-reset.scss");
require("./sass/blocks/_system-message.scss");
require("./sass/blocks/_auth.scss");
require("./sass/blocks/_reg.scss");
require("./sass/blocks/_checkbox.scss");
require("./sass/blocks/_bonuses.scss");
require("./sass/blocks/_coupon-generation.scss");
require("./sass/blocks/_qa.scss");
require("./sass/blocks/_mini-menu.scss");
require("./sass/blocks/_news.scss");
require("./sass/blocks/_contacts.scss");
require("./sass/blocks/_text-b.scss");
require("./sass/blocks/_photo-gallery-b.scss");
require("./sass/blocks/_video-b.scss");
require("./sass/blocks/_kits.scss");
require("./sass/blocks/_yac.scss");
require("./sass/blocks/_list-links.scss");
require("./sass/blocks/_material.scss");
require("./sass/blocks/_support.scss");
require("./sass/blocks/_tags.scss");
require("./sass/blocks/_link-material.scss");
require("./sass/blocks/_form-drop-down-b.scss");
require("./sass/blocks/_order.scss");
require("./sass/blocks/_table-history-orders.scss");
require("./sass/blocks/_history-orders-item.scss");
require("./sass/blocks/_information-list.scss");
require("./sass/blocks/_advantage-reg.scss");
require("./sass/blocks/_responsive-table.scss");
require("./sass/blocks/_product-collapse-block.scss");
require("./sass/blocks/_packaging.scss");
require("./sass/blocks/_pick-point.scss");
require("./sass/blocks/_wobblers.scss");
require("./sass/blocks/_toggle-box.scss");
require("./sass/blocks/_jquery-bar-rating.scss");
require("./sass/blocks/portal-link.scss");

require("./sass/blocks/_footer-sticky.scss");

require("./sass/blocks/_other.scss");



/** WEBPACK FOOTER **
 ** D:/phpstorm/szar/src/styles-entry.js
 **/